<div class="containerBlock">
<a href="javascript:void(0)" class="edit-grid" (click)="editBtn(id)">Edit</a>
<a href="javascript:void(0)" (click)="createDuplicateOrder(id)" class="edit-grid contentCopy">
  <span class="material-icons" title="Duplicate Order">content_copy</span>
</a>
</div>
